import React, { useEffect } from 'react'
import { Edit, SimpleForm, TextInput, NumberInput, useTranslate, BooleanInput, FormDataConsumer } from 'react-admin'
import { useFormContext, useWatch } from 'react-hook-form'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

const SyncLiquidationFields = () => {
  const { control, setValue } = useFormContext()
  const show = useWatch({ control, name: 'show' })

  useEffect(() => {
    if (!show) {
      setValue('rule_liquidation_type', [])
    }
  }, [show, setValue])

  return null
}

const transform = (data) => ({
  ...data,
  value: data.value !== null && data.value !== undefined && data.value !== '' && !isNaN(Number(data.value))
    ? Number(data.value)
    : 0,
})

export const FormulaGlobalVariablesEdit = (props) => {
  const translate = useTranslate()

  const ruleLiquidationTypes = [
    { short_name: 'RETAIL', long_name: translate('ra.field.retail') },
    { short_name: 'WHOLESALER', long_name: translate('ra.field.wholesaler') },
    { short_name: 'SUPPLIER', long_name: translate('ra.field.supplier') },
  ]

  return (
    <Edit {...props} actions={null} transform={transform}>
      <CardCommon title={translate('ra.entity.formula-global-variables')} actions={null}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['name']} />}>
          <SyncLiquidationFields />
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput disabled source='name' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.value')}>
              <NumberInput
                label=''
                source='value'
                defaultValue={0}
                parse={(val) => (val === '' || val === null || val === undefined || isNaN(val) ? 0 : Number(val))}
                fullWidth
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.show_breakdown')}>
              <BooleanInput label={translate('ra.field.show_breakdown')} source='show' fullWidth />
            </EditInputsWrap>
            <FormDataConsumer>
              {({ formData }) => {
                if (formData?.show) {
                  return (
                    <EditInputsWrap label={translate('ra.field.rule_type')}>
                      <SelectInput
                        source='rule_liquidation_type'
                        options={ruleLiquidationTypes}
                        label=''
                        multiple
                        optionValue='short_name'
                        optionsText={['long_name']}
                      />
                    </EditInputsWrap>
                  )
                }
                return null
              }}
            </FormDataConsumer>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}

